import Bowser from 'bowser'

const bowser =
  typeof window === 'undefined'
    ? undefined
    : Bowser.parse(window.navigator?.userAgent)
const bowserFlags = {
  mobile: bowser?.platform?.type === 'mobile',
  tablet: bowser?.platform?.type === 'tablet',
  android: bowser?.os.name === 'Android',
  ios: bowser?.os.name === 'iOS',
  ipad: bowser?.os.name === 'iOS' && bowser?.platform?.type === 'tablet',
  windows: bowser?.os.name === 'Windows',
}
const browserName = bowser?.browser?.name
export { Bowser as default, browserName, bowserFlags }
